import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import * as _ from 'underscore';
import {DataCenterService} from '../../../service/data-center.service';
import {forkJoin as observableForkJoin} from 'rxjs';
import {FormComponent} from '../../../basicComponent/form/form.component';
import {RequestDataService} from '../../../service/request-data.service';
import {AppConfigService} from '../../../service/app-config.service';
import {UtilsService} from '../../../service/utils.service';
import {ListActionService} from '../../../service/list-action.service';
import {NzModalService} from 'ng-zorro-antd';
import {SettingColumnService} from '../../../service/setting-column.service';
import {ConfirmModalService} from '../../../service/confirm-modal.service';
import {DataService} from '../data.service';
import * as moment from 'moment';
import {SetPointModalComponent} from '../set-point-modal/set-point-modal.component';

@Component({
  selector: 'app-word-list',
  templateUrl: './word-list.component.html',
  styleUrls: ['./word-list.component.css']
})
export class WordListComponent implements OnInit {

  @ViewChild(FormComponent ,{static: false}) childForm !: FormComponent;

  @ViewChild('listColumn',{static: false}) listColumn;


  // table 滚动条宽度
  public scrollWidth = '';

  // 分页下标
  public pageIndex: any = 1;
  // 每页显示数据
  public pageSize: any = 10;
  // 总条数
  public total: any = 0;
  // 当页条数
  nowCount: any = 0;

  //父级组件的数据对象
  @Input() parentData: any = {
    conditionColumns: {
      columns: []
    }
  };

  // 当前table的表头
  public showColumns: any = [];

  // 查询数据
  public conditionList: any[] = [];

  //排序字段的数组
  private sortArray: any[] = [];

  public checkbox = true;
  private allChecked = false;
  private indeterminate = false;

  private visibleCheck = {
    type: 'common'
  };

  // 列表页帮助文档
  private listHelpUrl = '';

  checkedAll = false;

  // 查询条件
  conditionColumn: any = {
    RESOURCES_STATE: '',
    RESOURCES_NAME: '',
    SITE_ID: '',
    CHANNEL_ID: '',
    AUDIT_USER_NAME: '',
    AUDIT_TIME: '',
    RESOURCES_TYPE: '',
    RESOURCES_LABEL: null
  };

  siteList = [];
  resourcesType = [];
  stateList = [];
  labelsList = [];
  // 栏目字典
  channelList = [];
  expandKeys = [];

  constructor(private requestDataService: RequestDataService,
              private appConfigService: AppConfigService,
              private dataCenterService: DataCenterService,
              private utils: UtilsService,
              private listAction: ListActionService,
              private modalService: NzModalService,
              private settingSerive: SettingColumnService,
              private confirmModal: ConfirmModalService,
              private dataService: DataService) {
  }

  // 时间框
  onChange (result) {
    if (result.length === 2) {
      this.conditionColumn.AUDIT_TIME_BEGIN = moment(result[0]).format('YYYY-MM-DD');
      this.conditionColumn.AUDIT_TIME_END = moment(result[1]).format('YYYY-MM-DD');
    } else {
      this.conditionColumn.AUDIT_TIME_BEGIN = '';
      this.conditionColumn.AUDIT_TIME_END = '';
    }
  }

  // 添加
  addGrouping() {
    this.switchPage('customForm', 'app-word-add-edit', this.parentData, 'add', 'addWord');
  }

  // 修改
  editGrouping() {
    if (this.selectOneData(this.parentData.data.data) !== 1) {
      return;
    }
    const resourcesId = _.find(this.parentData.data.data, oneData => {
      if (oneData['checked']) {
        this.parentData['RESOURCES_ID'] = oneData['ID'];
      }
      return oneData['checked'];
    });
    if (resourcesId['RESOURCES_STATE'] === 'PUSH') {
      return this.confirmModal.show('warning', {title: '已发布的资源不可以修改，若需修改请先下架。'});
    }
    this.switchPage('customForm', 'app-word-add-edit', this.parentData, 'modify', 'editWord');
  }

  //积分设置
  setPoints() {
    if (this.selectMore(this.parentData.data.data) < 1) {
      return;
    }
    this.modalService.create({
      nzTitle: null,
      nzWidth: 300,
      nzContent: SetPointModalComponent,
      nzWrapClassName: 'vertical-center-modal',
      nzOnOk: (response) => {
        const ids = [];
        _.filter(this.parentData.data.data, oneData => {
          if (oneData['checked']) {
            ids.push(oneData['ID']);
          }
          return oneData['checked'];
        });
        this.dataService.requestQuickSliver('/digital/setResourcePoint', {pointNum: response.point, resourceIds: ids}).subscribe(response => {
          if (response.state === 'success') {
            this.confirmModal.show('success', {title: '执行成功'});
            this.searchData();
            return true;
          } else {
            this.confirmModal.show('error', {title: '执行失败'});
          }
        });
      }
    });
  }

  // 修改状态
  updateState(pType) {
    let ok = true;
    let errorText = '';
    const ids = [];
    if (this.selectMore(this.parentData.data.data) < 1) {
      return;
    }
    const selectList = _.filter(this.parentData.data.data, oneData => {
      if (oneData['checked']) {
        ids.push(oneData['ID']);
      }
      return oneData['checked'];
    });
    switch (pType) {
      case 'PASS':
        _.each(selectList, oneData => {
          if (oneData['RESOURCES_STATE'] !== 'NO_AUDIT') {
            ok = false;
          }
        });
        if (!ok) {
          errorText = '只有待审核状态的数据才能执行该操作。';
        }
        break;
      case 'NO_PASS':
        _.each(selectList, oneData => {
          if (oneData['RESOURCES_STATE'] !== 'NO_AUDIT') {
            ok = false;
          }
        });
        if (!ok) {
          errorText = '只有待审核状态的数据才能执行该操作。';
        }
        break;
      case 'PUSH':
        _.each(selectList, oneData => {
          if (oneData['RESOURCES_STATE'] !== 'PASS' && oneData['RESOURCES_STATE'] !== 'OFF_SHELF') {
            ok = false;
          }
        });
        if (!ok) {
          errorText = '只有审核通过状态的数据才能执行该操作。';
        }
        break;
      case 'OFF_SHELF':
        _.each(selectList, oneData => {
          if (oneData['RESOURCES_STATE'] !== 'PUSH') {
            ok = false;
          }
        });
        if (!ok) {
          errorText = '只有已发布状态的数据才能执行该操作。';
        }
        break;
    }
    if (!ok) {
      return this.confirmModal.show('warning', {title: errorText});
    }
    const data = {
      id: ids,
      resourceState: pType
    };
    this.dataService.updateResourcesState(data).subscribe((rep)=>{
      if(rep.state === 'success'){
        this.confirmModal.show('success', {title: '执行成功'});
        this.searchData();
      }else{
        this.confirmModal.show('error', {title: '执行失败'});
      }
    });
  }

  // 删除
  deleteResources() {
    let ok = true;
    const ids = [];
    if (this.selectMore(this.parentData.data.data) < 1) {
      return;
    }
    _.each(this.parentData.data.data, oneData => {
      if (oneData['checked'] && oneData['RESOURCES_STATE'] !== 'PUSH') {
        ids.push(oneData['ID']);
      } else if (oneData['checked'] && oneData['RESOURCES_STATE'] === 'PUSH') {
        ok = false;
        return false;
      }
    });
    if (!ok) {
      return this.confirmModal.show('warning', {title: '已发布的数据不可以删除。'});
    }
    this.confirmModal.show('confirm', {
      title: '您确定删除吗？',
      suc: () => {
        this.dataService.resourcePicDelete(ids).subscribe((rep)=>{
          if(rep.state === 'success'){
            this.confirmModal.show('success', {title: '执行成功'});
            this.searchData();
          }else{
            this.confirmModal.show('error', {title: '执行失败'});
          }
        });
      }
    });
  }

  pageSearch(num) {
    this.pageIndex = num;
    this.searchData();
  }

  // 通用封装数据结果
  transformData(data) {
    // 重新覆盖 datacenter 数据
    this.parentData.pageSize = this.pageSize;
    this.parentData.data = data;
    this.total = data.page.rowCount;
    this.parentData.pageIndex = data.page.pageNum;
    // 覆盖当前数据到data-center;
    _.each(this.dataCenterService._dataObject.list, (item) => {
      if (item['id'] === this.parentData.id) {
        item = _.extend(item, this.parentData);
      }
    });
    this.dataCenterService.refreshDataCenterInStorage();
  }

  switchPage(pFormType, pCustomFormType, parentData, pModeType?, btnName?) {
    // 重新覆盖 datacenter 数据
    parentData.data = {};
    parentData.custormFormType = pCustomFormType;
    parentData.conditionColumns = {};
    parentData.formType = pFormType;
    parentData.modeType = pModeType;
    parentData.btnName = btnName;
    parentData.actionArray = [];
    // 覆盖当前数据到data-center;
    _.each(this.dataCenterService._dataObject.list, (item) => {
      if (item['id'] === parentData.id) {
        item = _.extend(item, parentData);
      }
    });
    this.dataCenterService.refreshDataCenterInStorage();
  }

  refreshStatus(): void {
    const validData = this.parentData.data.data.filter(value => !value.disabled);
    const allChecked = validData.length > 0 && validData.every(value => value.checked === true);
    const allUnChecked = validData.every(value => !value.checked);
    this.allChecked = allChecked;
    this.indeterminate = (!allChecked) && (!allUnChecked);
  }

  checkAll(value: boolean): void {
    this.parentData.data.data.forEach(data => {
      if (!data.disabled) {
        data.checked = value;
      }
    });
    this.refreshStatus();
  }

  handleClose(removedCondition: {}): void {
    // form 中数据清空
    this.conditionList = this.conditionList.filter(tag => tag !== removedCondition);
    _.each(this.childForm._validateForm['columns'], (item) => {
      if (removedCondition['column'] === item['column']) {
        item['model'] = null;
        if (_.contains(['date', 'datetime', 'dateRange', 'dateTimeRange'], item['component'])) {
          item['modelDate'] = null;
        }
        if (_.contains(['poplist', 'multipopCondition'], item['component'])) {
          item['modelName'] = '';
        }
      }
    });
    // 重新查询
    this.searchData();
  }

  /**
   * 清除条件调用方法
   */
  resetFilter() {
    this.conditionColumn = {
      RESOURCES_STATE: '',
      RESOURCES_NAME: '',
      SITE_ID: null,
      CHANNEL_ID: '',
      AUDIT_NAME: '',
      AUDIT_TIME: '',
      RESOURCES_TYPE: ''
    };
    this.searchData();
  }

  searchData(reset: boolean = false, condition?: {}, pSortBy?): void {
    if (reset) {
      this.parentData.pageIndex = 1;
    }
    this.requestDataService.getPaginationData('digitalResources/dr/dr_word_list.json', this.conditionColumn,  this.parentData.pageIndex, this.pageSize, pSortBy).subscribe((data: any) => {
      this.transformData(data);
      // 如果重新查询。则清楚掉详情的条件
      this.parentData.detailCondition = {};
      this.dataCenterService.refreshDataCenterInStorage();
      this.checkedAll = false;
    });
  }

  gotoDetail(oneData: string): void {
    this.parentData.RESOURCES_ID = oneData['ID'];
    this.switchPage('customForm', 'app-word-detail', this.parentData, 'wordDetail', 'wordDetail');
  }

  selectOneData(pListData): number {
    let iCount = 0;
    _.each(pListData, oneData => {
      if (oneData['checked']) {
        iCount++;
      }
    });
    if (iCount === 0) {
      this.confirmModal.show('warning', {
        'title': '温馨提示',
        'content': '请至少选择一条纪录！'
      });
      console.error('this action must select only one record ');
      return iCount;
    } else if (iCount > 1) {
      this.confirmModal.show('warning', {
        'title': '温馨提示',
        'content': '请只选择一条纪录！'
      });
      console.error('this action must select only one record ');
      return iCount;
    }
    return iCount;
  }

  selectMore(pListData): number {
    //计数，有多少条记录被勾选了。
    let iCount = 0;
    _.each(pListData, oneData => {
      if (oneData['checked']) {
        iCount++;
      }
    });
    if (iCount === 0) {
      this.confirmModal.show('warning', {
        'title': '温馨提示',
        'content': '请至少选择一条纪录！'
      });
      return iCount;
    }
    return iCount;
  }

  searchChannel(pSiteId) {
    if (!this.utils.Base_HasValue(pSiteId)) {
      return false;
    }
    this.requestDataService.getDataByCondition('digitalResources/dict/CHANNEL_NAME_SHOW.json', {SITE_ID: pSiteId}).subscribe((rep) => {
      this.channelList = rep['data'] || [];
      if (this.utils.Base_HasValue(this.channelList)) {
        this.channelList = this.utils.Base_ChannelData(this.channelList);
        for (const oneData of this.channelList) {
          this.expandKeys.push(oneData['key']);
        }
      }
    });
  }

  ngOnInit() {
    const parallel$ = observableForkJoin(
      this.requestDataService.getDataByCondition('digitalResources/dict/SITE_NAME.json'),
      this.requestDataService.getDataByCondition('digitalResources/dict/RESOURCES_TYPE.json'),
      this.requestDataService.getDataByCondition('digitalResources/dict/RESOURCES_STATE.json'),
      this.requestDataService.getPaginationData('digitalResources/dr/dr_word_list.json', null, this.parentData.pageIndex, this.pageSize)
    );
    parallel$.subscribe(
      values => {
        this.siteList = values[0]['data'];
        this.resourcesType = values[1]['data'];
        this.stateList = values[2]['data'];
        this.transformData(values[3]);
      }
    );
  }


}
